<template>
  <Transition
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    enter-active-class="transition ease-linear duration-200"
    leave-active-class="transition ease-linear duration-200 delay-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-show="isOpen" class="absolute inset-0 z-50 overflow-hidden">
      <div
        class="fixed inset-0 inline-block bg-gray-200 opacity-50"
        @click="toggle"
      ></div>

      <Transition
        enter-from-class="translate-y-full xl:translate-y-0 xl:translate-x-full"
        enter-to-class="translate-y-0 xl:translate-x-0"
        enter-active-class="transform transition-all duration-200"
        leave-active-class="transform transition-all duration-200"
        leave-from-class="translate-y-0 xl:translate-x-0"
        leave-to-class="translate-y-full xl:translate-y-0 xl:translate-x-full"
      >
        <div
          v-if="isOpen"
          class="fixed bottom-0 z-50 max-h-[calc(100vh-55px)] w-full overflow-y-auto overscroll-none bg-white px-8 py-0 shadow-sm xl:inset-y-0 xl:bottom-auto xl:right-0 xl:h-full xl:max-h-full xl:max-w-md xl:pt-8"
          data-testid="filter-slide-in"
        >
          <div class="relative">
            <slot v-bind="toggle" name="slideInContent">
              <slot name="slideInHeader" :toggle="toggle" />
              <slot name="slideInBody" />
              <div class="sticky bottom-0 z-10 bg-white py-4 md:py-8">
                <slot name="slideInActions" />
              </div>
            </slot>
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps({
  name: {
    type: String as PropType<string>,
    required: true,
  },
})
const emit = defineEmits(['open', 'close'])
const scope = effectScope()
onScopeDispose(() => scope.stop())
const { isOpen, toggle } = useSlideIn(props.name)
scope.run(() => {
  if (import.meta.server) {
    return
  }
  watch(isOpen, (newValue) => {
    emit(newValue ? 'open' : 'close')
  })
})
</script>
